.dropdown-wrapper {
  display: flex;

  &[data-hide='true'] {
    z-index: -1;
    pointer-events: none;
    visibility: hidden;
    opacity: 0;
    animation: dropdown-slide-out 300ms cubic-bezier(0.16, 1, 0.3, 1) forwards;
  }

  &[data-hide='false'] {
    z-index: auto;
    pointer-events: auto;
    visibility: visible;
    opacity: 1;
    animation: dropdown-slide-in 300ms cubic-bezier(0.16, 1, 0.3, 1);
  }

  @keyframes dropdown-slide-in {
    0% {
      opacity: 0;
      transform: translateX(100%);
    }
    100% {
      opacity: 1;
      transform: translateX(0);
    }
  }

  @keyframes dropdown-slide-out {
    0% {
      opacity: 1;
      transform: translateX(0);
    }
    100% {
      opacity: 0;
      transform: translateX(100%);
    }
  }
}

.container {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  flex: 1;
  border: 0.1rem solid var(--color-grayscale-trout);
  border-radius: var(--border-radius-small);

  & > *:first-child {
    flex: 1;
    width: 100%;
  }

  &:hover {
    border-color: var(--color-primary-crayola);
  }

  &[data-error='true'] {
    border-color: var(--color-secondary-roman, #db5c66);
  }
}

.trigger {
  user-select: none;
  display: flex;
  min-width: 7.2rem;
  padding: 0 0.8rem;
  justify-content: space-between;
  align-items: center;
  gap: 0.4rem;
  cursor: pointer;
  border-inline-start: 0.1rem solid var(--color-grayscale-trout);

  & + *[data-radix-popper-content-wrapper] {
    & > [data-radix-menu-content] {
      backdrop-filter: unset;
      background: var(--color-grayscale-tuna, #31343c);
      box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
      border-radius: var(--border-radius-small);
    }
  }
}

.label {
  text-align: start;
  font-size: 1.2rem;
  font-weight: 400;
}

.error {
  position: absolute;
  right: 0;
  bottom: -1.6rem;
  color: var(--color-secondary-roman, #db5c66);
  font-family: Inter, sans-serif;
  font-size: 1rem;
  letter-spacing: -0.2px;
  text-align: start;
  width: 100%;
}
